import { FC } from "react";
import { IconProps } from "./types";

export const PlusThick: FC<IconProps> = ({
  fill = "#111",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20a2 2 0 1 0 4 0v-6h6a2 2 0 1 0 0-4h-6V4a2 2 0 1 0-4 0v6H4a2 2 0 1 0 0 4h6v6z"
      fill={fill}
    />
  </svg>
);
